import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Loading... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconLoader = _resolveComponent("IconLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_IconLoader, { class: "animate-spin h-6 w-6" }, null, 512), [
      [_vShow, _ctx.loading]
    ]),
    (_ctx.loading)
      ? _renderSlot(_ctx.$slots, "loader", { key: 0 }, () => [
          _hoisted_1
        ])
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 64))
}